import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';

import { ADALandmarks, ADAARIARoles } from '../../../../models/ADA';

import Slot from '../Slot/Slot';

import './SlotMachine.scss';

const numberOfSlots = 6;
const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const SlotMachine = React.forwardRef(({ themes, themeIndex, onSpinStart, onSpinEnd, onIdleSpinStart, onIdleSpinEnd }, theRef) => {
  const [isMobile, setIsMobile] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const [slotMachineProps, setSlotMachineProps] = useState({
    width: 0,
    height: 0,
  });
  const smWrapper = useRef(null);
  const smSizer = useRef(null);
  // Refs 0 ... numberOfSlots - 1
  const slotIndicesArray = Array.from(Array(numberOfSlots).keys());
  const slotRefs = slotIndicesArray.map((_) => useRef(null));
  const positionRefs = slotIndicesArray.map((_) => useRef(null));
  const [spinningStates, setSpinningStates] = useState(slotIndicesArray.map((index) => false));
  const refSpinningStates = useRef(spinningStates);
  const [showingOverlayImage, setShowingOverlayImage] = useState(false);
  const [themeForOverlayIndex, setThemeForOverlayIndex] = useState(themeIndex);
  const refFirstRender = useRef(true);
  const refNoUserSpinYet = useRef(true);

  const handleScroll = () => {
    // if(creditsElement && creditsElement.current){
    //   const sliderRect = creditsElement.current.getBoundingClientRect();
    //   const windowHeight = getViewportDimensions().height;
    //   if ((sliderRect.y <= windowHeight)) {
    //     setCreditsActive(true);
    //   }
    //   else if ((sliderRect.y > windowHeight)) {
    //     setCreditsActive(false);
    //   }
    // }
  };

  const handleResize = () => {
    setIsMobile(getViewportDimensions().width <= mobileScreenThreshold);
    if (smSizer.current) {
      const sizerSize = smSizer.current.getBoundingClientRect();
      const height = Math.floor(sizerSize.height);
      if (height <= 0) {
        setTimeout(() => {
          handleResize();
        }, 100);
      } else {
        setSlotMachineProps({
          ...slotMachineProps,
          width: sizerSize.width,
          height,
        });
      }
    }
  }

  useLayoutEffect(() => {
    // handleScroll();

    // document.body.addEventListener('scroll', handleScroll);
    // window.addEventListener('resize', handleScroll);

    // return () => {
    //   document.body.removeEventListener('scroll', handleScroll);
    //   window.removeEventListener('resize', handleScroll);
    // };

    handleResize();
    window.addEventListener('resize', handleResize);
    
    refNoUserSpinYet.current = true;
    setTimeout(() => {
      doIdleSpinning();
    }, 4000);

    return () => {
      window.removeEventListener('resize', handleResize);
      refNoUserSpinYet.current = false;
    };
  }, []);

  useEffect(() => {
    if (refFirstRender.current) {
      refFirstRender.current = false;
    } else {
      doSomeSpinning();
    }
  }, [themeIndex]);

  const doSomeSpinning = () => {
    console.log("Now it's spinning");
    refNoUserSpinYet.current = false;
    setShowingOverlayImage(false);
    onSpinStart();
    refSpinningStates.current = [...spinningStates];
    setTimeout(() => {
      setThemeForOverlayIndex(themeIndex);
    }, 2 * 300);
    for (let i = 0; i < numberOfSlots; i ++) {
      const targetIndex = i;
      setTimeout(() => {
        const newSpinningStates = [...refSpinningStates.current];
        newSpinningStates[targetIndex] = true;
        setSpinningStates(newSpinningStates);
        refSpinningStates.current = newSpinningStates;
      }, 300 + i * 100);
    }

    setTimeout(() => {
      for (let i = 0; i < numberOfSlots; i ++) {
        const targetIndex = i;
        setTimeout(() => {
          const newSpinningStates = [...refSpinningStates.current];
          newSpinningStates[targetIndex] = false;
          setSpinningStates(newSpinningStates);
          refSpinningStates.current = newSpinningStates;
        }, i * 100);
      }
    }, 3000);

    setTimeout(() => {
      console.log("And now it's stopped spinning");
      setShowingOverlayImage(true);
      onSpinEnd();
    }, 3000 + 300 + numberOfSlots * 100 + 10);
  };

  const doIdleSpinning = () => {
    if (!refNoUserSpinYet.current) return;

    console.log("Now it's idle spinning");
    onIdleSpinStart();
    refSpinningStates.current = [...spinningStates];

    for (let i = 0; i < numberOfSlots; i ++) {
      const targetIndex = i;
      setTimeout(() => {
        const newSpinningStates = [...refSpinningStates.current];
        newSpinningStates[targetIndex] = true;
        setSpinningStates(newSpinningStates);
        refSpinningStates.current = newSpinningStates;
      }, i * 100);
    }

    setTimeout(() => {
      for (let i = 0; i < numberOfSlots; i ++) {
        const targetIndex = i;
        setTimeout(() => {
          const newSpinningStates = [...refSpinningStates.current];
          newSpinningStates[targetIndex] = false;
          setSpinningStates(newSpinningStates);
          refSpinningStates.current = newSpinningStates;
        }, i * 100);
      }
    }, 1000);

    setTimeout(() => {
      console.log("And now it's stopped idle spinning");
      onIdleSpinEnd();
      setTimeout(() => {
        doIdleSpinning();
      }, 4000);
    }, 1000 + numberOfSlots * 100 + 10);
  };

  const getSlots = (themes, smProps) => {
    const gap = getGap();
    const wrapper = smWrapper.current.getBoundingClientRect();
    const slotWidth = Math.round((wrapper.width - (numberOfSlots - 1) * gap) / numberOfSlots);
    let slots = [];
    slotRefs.forEach((ref, i) => {
      positionRefs[i].current = i * (slotWidth + gap);
      slots.push(
        <Slot
          ref={ref}
          key={i}
          themes={themes}
          totalWidth={smProps.width}
          unitWidth={slotWidth}
          unitHeight={smProps.height}
          offsetX={positionRefs[i].current}
          isSpinning={spinningStates[i]}
          targetIndex={themeIndex}
        />
      );
    });
    return slots;
  };

  const getGap = () => {
    if (getViewportDimensions().width <= mobileScreenThreshold) {
      return 2;
    } else {
      return 4;
    }
  };

  const getProperImage = (theme) => {
    if (getViewportDimensions().width <= mobileScreenThreshold) {
      return theme.MobileImage;
    } else {
      return theme.DesktopImage;
    }
  };

  return (
    <div className="ccw-slot-machine">
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className="cpvi-grid-col w12">
            <div className="ccw-sm-wrapper" style={{ height: `${slotMachineProps.height}px` }} ref={smWrapper}>
              <div className="ccw-sm-sizer" ref={smSizer}>
                <img src={mediaPath + getProperImage(themes[0]).Image} width="100%" tabIndex="-1" aria-hidden="true"/>
              </div>
              <div className="ccw-sm-slots-container">
                {
                  slotMachineProps.height
                  && 
                  getSlots(themes, slotMachineProps)
                }
              </div>
              <div className={`ccw-sm-overlay`}>
                {themes.map((theme, ind) => <div className="ccw-sm-ghost-image-wrapper" key={ind}><img src={`${mediaPath}${getProperImage(theme).Image}`}/></div>)}
                <div
                  className={`ccw-sm-overlay-image ${showingOverlayImage ? 'showing' : ''}`}
                  style={{
                    backgroundImage: themeForOverlayIndex === -1 ? '' : `url(${mediaPath}${getProperImage(themes[themeForOverlayIndex]).Image})`
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SlotMachine;